
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { DashboardContainerComponent } from './shared/components/dashboard/dashboard-container/dashboard-container.component';
import { DashboardHeaderComponent } from './shared/components/dashboard/dashboard-header/dashboard-header.component';
import { CommonModule } from '@angular/common';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HeaderModule } from './shared/components';
import { AuthGuardService } from './shared/components/framework/services/auth-guard.service';
import { HomeComponent } from './pages/home/home.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { TasksComponent } from './pages/tasks/tasks.component';
import { KanbanComponent } from './pages/kanban/kanban.component';
import { PayoffPaydownComponent } from './pages/dataentry/payoff-paydown/payoff-paydown.component';
import { DataGridComponent } from './shared/components/data-grid/data-grid.component';
import { TaskDetailComponent } from './pages/tasks/task-detail/task-detail.component';
import { NewTaskComponent } from './pages/tasks/new-task/new-task.component';
import {
  DxDataGridModule, DxFormModule, DxDrawerModule, DxSortableModule, DxFileUploaderModule, DxButtonModule, DxDropDownButtonModule,
  DxTooltipModule, DxValidatorModule, DxMenuModule, DxLoadPanelModule, DxContextMenuModule, DxTabsModule, DxPopupModule, DxTemplateModule, DxSelectBoxModule,
  DxPieChartModule, DxChartModule, DxFileManagerModule, DxCheckBoxModule, DxTreeListModule, DxRadioGroupModule, DxTagBoxModule,
  DxLookupModule, NestedOptionHost, DxAccordionModule, DxBoxModule, DxTextAreaModule, DxDateBoxModule, DxChatModule, DxListModule,
  DxResizableModule, DxTileViewModule, DxTextBoxModule, DxNumberBoxModule, DxPaginationModule
} from 'devextreme-angular';
import { DxoPositionModule, DxoHeightModule, DxoTooltipModule, DxoPermissionsModule, DxiToolbarItemModule, DxoHeaderFilterModule, DxoEditingModule, DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { DashboardPieChartsComponent } from './shared/components/dashboard/dashboard-charts/dashboard-pie-charts.component';
import { DashboardBarChartsComponent } from './shared/components/dashboard/dashboard-charts/dashboard-bar-charts/dashboard-bar-charts.component';
import { DashboardTableComponent } from './shared/components/dashboard/dashboard-charts/dashboard-table/dashboard-table.component';
import { TestComponent } from './shared/components/test/test.component';
import { DocumentsComponent } from './shared/components/documents/documents.component';
import { VoucherComponent } from './pages/dataentry/voucher/voucher/voucher.component';
import { MaterialModule } from './shared/material-module.module';
import { TopNavComponent } from './shared/components/framework-ui/navigation/header/top-nav/top-nav.component';
import { LogoutDialogComponent } from './shared/components/framework-ui/navigation/logout/logout-dialog/logout-dialog.component';
import { LoginComponent, LoginModule } from './shared/components/framework/login/login.component';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { SignInRedirectCallbackComponent } from './shared/components/framework-ui/navigation/signin-redirect-callback.component';
import { SignOutRedirectCallbackComponent } from './shared/components/framework-ui/navigation/signout-redirect-callback.component';
import { GenerateTasksComponent } from './pages/generate-tasks/generate-tasks.component';
import { CapitalizeFirstPipe, FileDatePipe, FormatAndCapitalizePipe, FormatBooleanNumersDatesPipe, FormatTaskDataPipe } from './pipes/pipes';
import { GridButtonsPipe } from './shared/components/data-grid/pipes/grid-buttons.pipe';
import { StatusClassPipe } from './shared/components/data-grid/pipes/status-class.pipe';
import { DueDateClassPipe } from './shared/components/data-grid/pipes/due-date-class.pipe';
import { BooleanDisplayPipe, IsBooleanYesPipe } from './shared/components/data-grid/pipes/boolean-display.pipe';
import { FileUploadComponent } from './shared/components/dynamic-form-widgets/file-upload/file-upload.component';
import { ChatComponent } from './shared/components/chat/chat.component';
import { UserLookupComponent } from "./shared/components/user-lookup/user-lookup.component";
import { BorrowerDrawRequestComponent } from './pages/dataentry/borrower-draw-request/borrower-draw-request.component';
import { ServiceRequestComponent } from './pages/dataentry/service-request/service-request.component';
import { ServiceRequestDynamicComponent } from './pages/dataentry/service-request-dynamic/service-request-dynamic.component';
import { PipelineComponent } from './pages/dataentry/pipeline/pipeline.component';
import { FileViewerComponent } from './shared/components/file-viewer/file-viewer.component';
import { ModificationComponent } from './pages/dataentry/modification/modification.component';
import { TreasuryRequestComponent } from './pages/dataentry/treasury-request/treasury-request.component';
import { DefaultNotificationComponent } from './pages/dataentry/default-notification/default-notification.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { VendorRequestComponent } from './pages/dataentry/vendor-request/vendor-request.component';
import { RejectTasksComponent } from './pages/tasks/reject-tasks/reject-tasks.component';
import { SandboxComponent } from './pages/sandbox/sandbox.component';
import { NotificationsComponent } from './shared/components/notifications/notifications.component';
import { CommentComponent } from './shared/components/comment/comment.component';
import { FandCGeneratorComponent } from './pages/dataentry/fandc-generator/fandc-generator.component';
import { StoreModule } from '@ngrx/store';
import { fandCGeneratorReducer } from './pages/dataentry/fandc-generator/store/fandc-generator.reducer';
import { EffectsModule } from '@ngrx/effects';
import { FandCGeneratorEffects } from './pages/dataentry/fandc-generator/store/fandc-generator.effects';
import { SuspenseComponent } from './pages/dataentry/suspense/suspense.component';
import { HoldTaskComponent } from './pages/tasks/block-task/hold-task.component';
import { LoanAmountsComponent } from '../app/shared/components/loan-amounts/loan-amounts.component';
import { FieldChangeCommentComponent } from './pages/tasks/task-detail/field-change-comment/field-change-comment.component';
import { TaskHistoryComponent } from './shared/components/task-history/task-history.component';
import { LoanAmountGridComponent } from './shared/components/dynamic-form-widgets/loan-amount-grid/loan-amount-grid.component';

const routes: Routes = [
  { path: '', redirectTo: '/tasks', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'signin-callback', component: SignInRedirectCallbackComponent },
  { path: 'signout-callback', component: SignOutRedirectCallbackComponent },

  {
    path: 'tasks',
    component: TasksComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'configuration/generatetasks',
    component: GenerateTasksComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'sandbox',
    component: SandboxComponent,
    canActivate: [AuthGuardService]
  },
  // Wildcard route - must be last
  {
    path: '**',
    redirectTo: '/login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false }),
  StoreModule.forFeature('fandCGenerator', fandCGeneratorReducer),
  EffectsModule.forFeature([FandCGeneratorEffects]),
    DxDataGridModule,
    DxFormModule,
    DxDrawerModule,
    DxScrollViewModule,
    DxSortableModule,
    DxFileUploaderModule,
    DxButtonModule,
    DxTooltipModule,
    DxValidatorModule,
    DxMenuModule,
    DxDropDownButtonModule,
    DxLoadPanelModule,
    DxoPositionModule,
    DxoHeightModule,
    DxoTooltipModule,
    DxContextMenuModule,
    DxTabsModule,
    DxToolbarModule,
    DxPieChartModule,
    DxChartModule,
    DxFileManagerModule,
    DxoPermissionsModule,
    DxPopupModule,
    DxiToolbarItemModule,
    DxTemplateModule,
    DxSelectBoxModule,
    MaterialModule,
    CommonModule,
    HeaderModule,
    LoginModule,
    DxCheckBoxModule,
    DxTreeListModule,
    DxRadioGroupModule,
    DxoHeaderFilterModule,
    DxTagBoxModule,
    DxChatModule,
    DxLookupModule,
    UserLookupComponent,
    DxAccordionModule,
    DxBoxModule,
    DxTextAreaModule,
    DxDateBoxModule,
    DxListModule,
    DxResizableModule,
    DxTileViewModule,
    DxoEditingModule,
    DxiValidationRuleModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxPaginationModule,
    LoanAmountsComponent
  ],
  providers: [
    AuthGuardService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    NestedOptionHost
  ],
  exports: [RouterModule, FileDatePipe, CapitalizeFirstPipe, FormatAndCapitalizePipe, FormatBooleanNumersDatesPipe, FormatTaskDataPipe],
  declarations: [
    HomeComponent,
    ProfileComponent,
    TasksComponent,
    KanbanComponent,
    DashboardComponent,
    PayoffPaydownComponent,
    DataGridComponent,
    TaskDetailComponent,
    DashboardContainerComponent,
    DashboardHeaderComponent,
    DashboardPieChartsComponent,
    DashboardBarChartsComponent,
    DashboardTableComponent,
    TestComponent,
    DocumentsComponent,
    VoucherComponent,
    TopNavComponent,
    LogoutDialogComponent,
    TopNavComponent,
    NewTaskComponent,
    GenerateTasksComponent,
    FileDatePipe,
    CapitalizeFirstPipe,
    FormatAndCapitalizePipe,
    FormatBooleanNumersDatesPipe,
    FormatTaskDataPipe,
    GridButtonsPipe,
    StatusClassPipe,
    DueDateClassPipe,
    BooleanDisplayPipe,
    IsBooleanYesPipe,
    FileUploadComponent,
    ChatComponent,
    BorrowerDrawRequestComponent,
    ServiceRequestComponent,
    ServiceRequestDynamicComponent,
    PipelineComponent,
    FileViewerComponent,
    ModificationComponent,
    TreasuryRequestComponent,
    DefaultNotificationComponent,
    VendorRequestComponent,
    RejectTasksComponent,
    SandboxComponent,
    NotificationsComponent,
    CommentComponent,
    HoldTaskComponent,
    FandCGeneratorComponent,
    SuspenseComponent,
    FieldChangeCommentComponent,
    TaskHistoryComponent,
    LoanAmountGridComponent
  ]
})
export class AppRoutingModule { }
